module.exports = __webpack_public_path__ + "img/labor-day-love.66d46f15.png";